import { Component } from 'react';

import { Next, Previous } from '../icons';

import './style.css';

class Pagination extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hellipStart: false,
      hellipEnd: false,
      pageList: null,
    };
  }

  componentDidMount = () => {
    this.updatePagination();
  };

  updatePagination = () => {
    const { totalPages, currentPage } = this.props;
    let hellipStart = false;
    let hellipEnd = false;

    let pageList = Array.from(Array(totalPages), (_, x) => x + 1);

    pageList.shift();
    pageList.pop();

    if (totalPages > 6) {
      if (currentPage <= 3) {
        pageList = pageList.slice(0, 4);
        pageList.unshift(1);
        pageList.push(totalPages);

        hellipEnd = true;
      } else if (currentPage > 3 && currentPage <= totalPages - 4) {
        pageList = pageList.slice(currentPage - 3, currentPage + 1);
        pageList.unshift(1);
        pageList.push(totalPages);

        hellipStart = true;
        hellipEnd = true;
      } else {
        pageList = pageList.slice(totalPages - 6, totalPages - 1);
        pageList.unshift(1);
        pageList.push(totalPages);

        hellipStart = true;
      }
    } else {
      if (totalPages !== 1) {
        pageList.unshift(1);
      }

      pageList.push(totalPages);
    }

    this.setState({
      hellipStart,
      hellipEnd,
      pageList
    });
  };

  nextPage = () => {
    let { currentPage } = this.props;

    if (currentPage < this.props.totalPages) {
      currentPage += 1;
    } else {
      return;
    }

    this.props.action(currentPage);
  };

  prevPage = () => {
    let { currentPage } = this.props;
    if (currentPage > 1) {
      currentPage -= 1;
    } else {
      return;
    }

    this.props.action(currentPage);
  };

  goToPage = (goToPageValue) => {
    if (
      !goToPageValue ||
      goToPageValue < 1 ||
      goToPageValue > this.props.totalPages ||
      Number.isNaN(goToPageValue)
    ) {
      this.setState({ notificationSearchErrorOpen: true });
    } else {
      this.props.action(goToPageValue);
    }
  };

  componentDidUpdate(prevProps) {
    if (
      this.props.currentPage !== prevProps.currentPage ||
      this.props.totalPages !== prevProps.totalPages
    ) {
      this.updatePagination();
    }
  }

  render() {
    return (
      <div className="pagination">
        <button
          className="is-previous"
          onClick={() => this.prevPage()}
          disabled={this.props.currentPage === 1}
        >
          <span className="symbol">
            <Previous className="symbol-left-arrow" height={14} width={14} />
          </span>
        </button>
        {this.state.pageList
          ? this.state.pageList.map(i => (
            <button
              key={i}
              className={
                (this.props.currentPage === i && 'is-active') +
                ((this.state.hellipEnd && i === this.props.totalPages) && ' is-end') +
                ((this.state.hellipStart && i === 1) && ' is-start')
              }
              onClick={() => this.goToPage(i)}
            >
              {i}
            </button>
          ))
          : null}
        <button
          className="is-next"
          onClick={() => this.nextPage()}
          disabled={this.props.currentPage === this.props.totalPages}
        >
          <span className="symbol">
            <Next className="symbol-right-arrow" height={14} width={14} />
          </span>
        </button>
      </div>
    );
  }
}

export default Pagination;
